import { Button, Popup as DXPopup } from "devextreme-react";
import { t } from "i18next";
import React from "react";

import { useScreenSize } from "../../hook/useScreenSize";
import { Col } from "../layout/grid/Col";
import { Row } from "../layout/grid/Row";

interface PopupProps {
    visible: boolean
    title: string
    message?: string
    onClose?: () => void
    onOk?: () => void
}

export default function Popup(props: PopupProps) {
    const { isXSmall } = useScreenSize()

    return (
        <DXPopup
            className="popup"
            visible={props.visible}
            dragEnabled={false}
            hideOnOutsideClick={true}
            showCloseButton={true}
            onHiding={props.onClose}
            height={isXSmall ? "80%" : "50%"}
            width={isXSmall ? "80%" : "50%"}
            title={props.title}>
            <Col height={"100%"} grow={0}>
                <Row grow={1} alignItems="flex-end">
                    {props.message && <span>{props.message}</span>}
                </Row>
                <Row>
                    <Col justifyContent="end">
                        <Button type="default" className="border-radius-small" onClick={props.onOk}>{t("OK")}</Button>
                    </Col>
                    <Col justifyContent="end">
                        <Button style={{border: "1px solid #e0e0e0"}} stylingMode="contained"  onClick={props.onClose}>{t("Cancel")}</Button>
                    </Col>
                </Row>
            </Col>
        </DXPopup>
    )
}
